import { BaseFirestoreRepository } from 'core/base-firestore.repository';

import { Product } from './product.model';

export default class ProductRepository extends BaseFirestoreRepository<Product> {
  constructor() {
    super('chefs_assistant_products');
  }

  async getAllOrderByProductName() {
    return this.getAll([['productName', 'asc']]);
  }
}
